/*eslint-disable*/
import React, { useState, useEffect, Component, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Label,
  Input,
  FormGroup,
Container ,
  
} from "reactstrap";
import VideoConference from "../VideoConference";
import translateText from "common/src/other/TranslationFunction";
import { FirebaseContext } from "common";
import { makeStyles } from "@material-ui/core/styles";
import "react-chat-elements/dist/main.css";
// import "react-sortable-tree/style.css";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { language } from "config";
import {
  Select,
  TextField,
  MenuItem,
  FormControl,
  InputLabel
} from "@material-ui/core";
import MedicalHistoryDialog from "components/MedicalHistory";
// import { MessageList, MessageBox, ChatList, Avatar } from "react-chat-elements";
import CardFooter from "components/Card/CardFooter";
import AudiologyForm from "./Forms/AudiologyForm";
import DentalForm from "./Forms/DentalForm";
import OPTForm from "./Forms/OPTForm";
import PrimaryHealthCare from "./Forms/PrimaryHealthCare";
import AncAssesment from "./Forms/AncAssesment";
import AncAssesmentB from "./Forms/AncAssesmentB";
import AncAssesmentC from "./Forms/AncAssesmentC";
import ProgressReport from "./Forms/ProgressReport";
import ProofRecord from "./Forms/ProofRecord";
import Returns from "./Forms/Returns";
import medicForm from "../../assets/medic-icons/icon-form-general@2x.png";
import refIcon from "../../assets/medic-icons/icon-places-hospital@2x.png";
import medIcon from "../../assets/medic-icons/icon-healthcare-generic@2x.png";
import { useNavigate, useLocation } from "react-router-dom";
// import Chat from "../Chat";
import UsersCombo from "components/UsersCombo";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "components/CustomInput/CustomInput.js";
import MaterialTable from "material-table";
import Notes from "views/Consultations/Notes";
import DeviceExposure from "views/Consultations/DeviceExposure";
import DrugExposure from "views/Consultations/DrugExposure";
import Observations from "views/Consultations/Observations";
import Procedures from "views/Consultations/Procedures";
const AppointmentScreen = (props) => {
  const medical = useSelector(
    (state) => state.medicalRecords.medicalHistoryRecords
  );
  // const docNotesRef = useRef();
  const auth = useSelector((state) => state.auth);
  const { api } = useContext(FirebaseContext);
  const {
    GetDateString,
    fetchMedicalHistory,
    addDoctorsNotes,
    updateBooking,
    fetchChatMessages,
    deleteMeetingRoom,
    addBooking,
    addRefBooking,
    endtheConsultation
  } = api;
  const dispatch = useDispatch();
  const classes = useStyles();
  const location = useLocation();
  const Booking = location.state.Booking;
  const bookinglistdata = useSelector((state) => state.bookinglistdata);
  const settings = useSelector((state) => state.settingsdata.settings);
  const userdata = useSelector((state) => state.usersdata);
  const [users, setUsers] = useState(null);
  const [arabicText, setArabicText] = useState("");
  const [translatedText, setTranslatedText] = useState("");
  const [openFPModal, setOpenFPModal] = React.useState(false);
  const [openMedModal, setOpenMedModal] = React.useState(false);
  const [openPpModal, setOpenPpModal] = React.useState(false);
  const [openPModal, setOpenPModal] = React.useState(false);
  const [openCModal, setOpenCModal] = React.useState(false);
  const [openOModal, setOpenOModal] = React.useState(false);
  const usersdata = useSelector((state) => state.doctors);
  const [activeTab, setActiveTab] = useState(0);
  // const bookingdata = useSelector((state) => state.bookingdata);
  const referraldoctors = useSelector(
    (state) => state.referraldoctors.referraldrs
  );
  const [activeMedTab, setActiveMedTab] = useState(0);
  const [updatebooking, setupdatebooking] = useState(Booking);
  const [DoctorsRef, setDoctorsRef] = useState([]);
  const [userCombo1, setUserCombo1] = useState(null);
  const [refSpec, setrefSpec] = useState(false);
  const navigate = useNavigate();
  const [acceptbutton, setAcceptbutton] = useState(false);
  const [commonAlert, setCommonAlert] = useState({
    open: false,
    msg: "",
    title: ""
  });
  /////////////////////////////////
  const [referralreason, setreferralreason] = useState();
  const [certificate, setCertificate] = useState({});
  const [perscriptions, setPerscriptions] = useState({});
const isEditing = location.state?.isEditing || false;



  // const getHtml = (value) =>
  // draftToHtml(convertToRaw(value.getCurrentContent()));
  const specialities = useSelector(
    (state) => state.specialitytypes.specialities
  );
  const [specialityTypes, setSpecialityTypes] = useState([]);

  useEffect(() => {
    if (specialities) {
      let arr = [];
      for (let i = 0; i < Object.values(specialities).length; i++) {
        arr.push({
          value: Object.values(specialities)[i],
          label: Object.values(specialities)[i]
        });
      }
      setSpecialityTypes(arr);
      console.log("here", specialityTypes);
    }
  }, []);
const InfoItem = ({ label, value }) => (
  <FormGroup>
    <Label className="text-muted small">{label}</Label>
    <p className="font-weight-bold">{value}</p>
  </FormGroup>
);

  const enterChangeO = async (e) => {
    console.log("Changes made", e);
    let arr = [];
    for (let i = 0; i < e.blocks.length; i++) {
      arr = e.blocks;
    }
    setArabicText(arr);

    const extractedText = arr.map((block) => block.text).join(" ");

    if (!extractedText.trim()) {
      console.log("No text to translate.");
      return;
    }

    console.log("Translating", extractedText);

    const result = await translateText(extractedText);

    setTranslatedText(result);

    console.log("Results:", result);

    setupdatebooking({
      ...updatebooking,
      observations: result
    });

    console.log(updatebooking);
  };



const handleMedTabChange = (event, newValue) => {
  setActiveMedTab(newValue);
};


    const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const enterChange = (e) => {
    let arr = [];
    for (let i = 0; i < e.blocks.length; i++) {
      arr = e.blocks;
    }
    setupdatebooking({
      ...updatebooking,
      certificate: certificate
    });
    setCertificate(arr);
  };

  const onSave = () => {
    dispatch(updateBooking(updatebooking));
  };

  const enterChangeP = (e) => {
    let arr = [];
    for (let i = 0; i < e.blocks.length; i++) {
      arr = e.blocks;
    }
    setupdatebooking({
      ...updatebooking,
      persciption: perscriptions
    });
    setPerscriptions(arr);
  };
  const onSaveP = () => {
    dispatch(updateBooking(updatebooking));
  };
  useEffect(() => {
    console.log("i am the referral doctors: ", referraldoctors);

    let arr = [];
    for (let i = 0; i < referraldoctors.length; i++) {
      let user = referraldoctors[i];
      if (
        auth.info.profile.userType === "doctor" &&
        auth.info.profile.practiceNumber === user.practiceNumber
      ) {
        arr.push({
          firstName: user.firstName,
          lastName: user.lastName,
          mobile: user.mobile,
          email: user.email,
          uid: user.id,
          practiceNumber: user.practiceNumber,
          practiceName: user.practiceName,
          referralId: user.referralId,
          refferalPracticeNumber: user.refferalPracticeNumber,
          specialityType: user.specialityTypes,
          desc:
            user.firstName +
            " " +
            user.lastName +
            " (" +
            user.specialityTypes +
            ") "
          // pushToken: user.pushToken,
        });
        setDoctorsRef(arr);
      } else {
        if (referraldoctors !== null) {
          setDoctorsRef(referraldoctors);
        }
      }
    }
  }, [referraldoctors]);
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };
  useEffect(() => {
    dispatch(fetchChatMessages(Booking.id));
    if (userdata.users) {
      let arr = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        arr.push({
          firstName: user.firstName,
          lastName: user.lastName,
          mobile: user.mobile,
          email: user.email,
          uid: user.id,

          desc:
            user.firstName +
            " " +
            user.lastName +
            " (" +
            user.mobile +
            ") " +
            user.email,
          pushToken: user.pushToken
        });
      }

      setUsers(arr);
      console.log("this is the users: ", arr);
    }
  }, [userdata.users]);

  useEffect(() => {
    if (userdata.users) {
      let arr = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        arr.push({});
      }

      setUsers(arr);
    }
  }, [userdata.users]);

  const handleCloseEvent = () => {
    setOpenFPModal(false);
  };
  const handleOpenEvent = () => {
    setOpenFPModal(true);
  };
  const handleCloseMed = () => {
    setOpenMedModal(false);
  };
  const handleMedOpen = () => {
    setOpenMedModal(true);
  };
  const handlePpClose = () => {
    setOpenPpModal(false);
  };
  const handlePpOpen = () => {
    setOpenPpModal(true);
  };
  const handleOpen = () => {
    setOpenOModal(true);
  };
  const handlePClose = () => {
    setOpenPModal(false);
  };
  const handlePOpen = () => {
    // navigate({
    //   pathname: "/wysiwig",
    //   state: { Booking },
    // });

    setOpenPModal(true);
  };
  const handleCClose = () => {
    setOpenCModal(false);
  };

  const handleOClose = () => {
    setOpenOModal(false);
  };
  const handleCOpen = () => {
    setOpenCModal(true);
  };



  const Accept = () => {
    if (auth.info.profile.userType === "practiceadmin")
      if (updatebooking.status === "ACCEPTED") {
        setCommonAlert({
          open: true,
          msg: "Referral send",
          title: "Thank you"
        });
      } else {
        navigate("/bookingrequest");
      }

    dispatch(updateBooking(updatebooking));
    handleCloseEvent();
  };





const endConsultation = () => {
  const updated = { ...updatebooking, status: "COMPLETE" };  
  setupdatebooking(updated);
  console.log("this is the update to be completed", updated);
  dispatch(endtheConsultation(updated));
  navigate("/bookings", { state: { Booking: updated } });
};


  const [state, setstate] = useState({
    refferalDoctor: false,
    refferalType: false,
    // this is the format required for the api
    refferalDate: new Date().toISOString().substring(0, 19),
    refferalNote: ""
  });
  const makeRefferal = () => {
    let refferal = {
      ...updatebooking,
      refferalStatus: "NEW",
      refferal: {
        refferalDoctor: state.refferalDoctor,
        refferalType: state.refferalType,
        refferalDate: state.refferalDate,
        refferalNote: state.refferalNote
      }
    };
    let newBookingRef = {
      ...updatebooking,
      status: "NEW",
      refferal: {
        refferalDoctor: state.refferalDoctor,
        refferalType: state.refferalType,
        refferalDate: state.refferalDate,
        refferalNote: state.refferalNote
      },
      settings: settings
    };
    dispatch(updateBooking(refferal));
    if (newBookingRef) {
      dispatch(addRefBooking(newBookingRef));
    }
    // dispatch(addBooking(refferal));
    setOpenFPModal(false);
    // console.log(refferal);
  };

  return (
    <>
         <Container fluid className="py-4"> {/* Added Container with padding */}
      <Row className="justify-content-center">
        <Col md="12">
          {/* Patient Info Card */}
          <Card className={classes.patientInfoCard}>
            <CardBody>
              <Row>
                <Col md="3">
                  <InfoItem label="Name" value={Booking.patientName} />
                </Col>
                <Col md="3">
                  <InfoItem label="Booking ID" value={Booking.id} />
                </Col>
                <Col md="3">
                  <InfoItem label="Booking Name" value={Booking.bookingName} />
                </Col>
                <Col md="3">
                  <InfoItem label="Date/Time" value={Booking.eventDate} />
                </Col>
              </Row>
            </CardBody>
          </Card>

      
           {openMedModal && (
  <MedicalHistoryDialog
    open={openMedModal}
    onClose={() => handleCloseMed()}
    Booking={Booking}
  />
)}

          {/* Horizontal Button Row - Centered with full width */}
          {/* <Row className="mt-4 mb-4 justify-content-center">
            <Col md="10">
              <div className="d-flex flex-wrap gap-2 justify-content-center">
                <Button
                       size="lg"
                  color="primary"
                  onClick={handlePpOpen}
                  className="px-4"
                >
                  {"Patient Details"}
                </Button>
                <Button
                       size="lg"
                  color="primary"
                  onClick={handleMedOpen}
                  className="px-4"
                >
                  {"Medical History"}
                </Button>
                <Button
                       size="lg"
                  color="primary"
                  onClick={handleOpenEvent}
                  className="px-4"
                >
                  {"Refferal"}
                </Button>
                <Button
                       size="lg"
                  color="primary"
                  onClick={handleCOpen}
                  className="px-4"
                >
                  {"Certificate"}
                </Button>
                <Button
                       size="lg"
                  color="primary"
                  onClick={() => {
                    openInNewTab(Booking?.videoconferencelink);
                  }}
                  className="px-4"
                >
                  {"Video Consultation"}
                </Button>
                <Button
                       size="lg"
                  color="info"
                  onClick={endConsultation}
                  className="px-4"
                >
                  {"End Consultation"}
                </Button>
              </div>
            </Col>
          </Row> */}

          {/* Tabbed Tables - Now uses full width */}
          <Card className="mt-3">
              <CardHeader className="bg-light p-3">
                <div className="d-flex justify-content-between align-items-center border-bottom">
                  {/* Left side: Tabs */}
                  <div className="d-flex">
                    <div
                      className={`tab-header ${activeTab === 0 ? 'active' : ''}`}
                      onClick={() => setActiveTab(0)}
                    >
                      <span className="fs-5">Observations</span>
                    </div>
                    <div
                      className={`tab-header ${activeTab === 1 ? 'active' : ''}`}
                      onClick={() => setActiveTab(1)}
                    >
                      <span className="fs-5">Assign Prescriptions</span>
                    </div>
                    <div
                      className={`tab-header ${activeTab === 2 ? 'active' : ''}`}
                      onClick={() => setActiveTab(2)}
                    >
                      <span className="fs-5">Notes</span>
                    </div>
                  </div>

                  {/* Right side: Buttons */}
                  <div className="d-flex flex-wrap gap-2">
                    <Button size="lg" color="primary" onClick={handlePpOpen} className="px-4">
                      Patient Details
                    </Button>
                    <Button size="lg" color="primary" onClick={handleMedOpen} className="px-4">
                      Medical History
                    </Button>
                    <Button size="lg" color="primary" onClick={handleOpenEvent} className="px-4">
                      Refferal
                    </Button>
                    <Button size="lg" color="primary" onClick={handleCOpen} className="px-4">
                      Certificate
                    </Button>
                    <Button
                      size="lg"
                      color="primary"
                      onClick={() => openInNewTab(Booking?.videoconferencelink)}
                      className="px-4"
                    >
                      Video Consultation
                    </Button>
                    <Button
                      size="lg"
                      color="info"
                      onClick={endConsultation}
                      className="px-4"
                    >
                      {isEditing ? "End Editing" : "End Consultation"}
                    </Button>
                  </div>
                </div>
              </CardHeader>

            <CardBody className="p-0">
              {activeTab === 0 && (
               <div className="p-4">
                  {/* Observations content */}
                  <Observations Booking={Booking} />
                </div>
              )}
              {activeTab === 1 && (
                 <div className="p-4">
                  <DrugExposure Booking={Booking} />
                </div>
              )}
              {activeTab === 2 && (
                 <div className="p-4">
                  <Notes Booking={Booking} />
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
     

      {/* Patient Details Dialog */}
      <Dialog
        open={openPpModal}
        onClose={handlePpClose}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">{"Patient Details"}</DialogTitle>
        <DialogContent>
          <FormGroup>
            <span>Name of Patient </span>
            <p className="description">{Booking.patientName}</p>
          </FormGroup>

          <FormGroup>
            <span>Patient Contact Number: </span>
            <p className="description">{Booking.patientContact}</p>
          </FormGroup>

          <FormGroup>
            <span>Email of Patient : </span>
            <p className="description">{Booking.patientEmail}</p>
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handlePpClose}>
            {"Close"}
          </Button>
        </DialogActions>
      </Dialog>

   

      {/* Referral Dialog - Fixed with full content */}
      <Dialog
        open={openFPModal}
        onClose={handleCloseEvent}
        aria-labelledby="form-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">{"Make A Refferal"}</DialogTitle>

        <DialogContent>
          <Label>Patient's Details </Label>
        </DialogContent>

        <DialogContent>
          <Row>
            <Col>
              <Label>Patient: </Label>
            </Col>
            <Col>{Booking.patientName}</Col>
          </Row>
          <Row>
            <Col>
              <Label>Contact Number: </Label>
            </Col>
            <Col>{Booking.patientContact}</Col>
          </Row>
          <Row>
            <Col>
              <Label>Email: </Label>
            </Col>
            <Col>{Booking.patientEmail}</Col>
          </Row>
        </DialogContent>

        <hr />
        <DialogContent>
          <Label>Doctor's Details </Label>
        </DialogContent>
        <DialogContent>
          <Row>
            <Col>
              <Label>Doctor : </Label>
            </Col>
            <Col>
              {" "}
              {Booking.doctor.firstName} {Booking.doctor.lastName}
            </Col>
          </Row>
          <Row>
            <Col>
              <Label>Contact Number: </Label>
            </Col>
            <Col>{Booking.doctor.mobile}</Col>
          </Row>
          <Row>
            <Col>
              <Label>Email: </Label>
            </Col>
            <Col>{Booking.doctor.email}</Col>
          </Row>
        </DialogContent>
        <hr />
        <DialogContent>
          <FormControl fullWidth>
            <InputLabel id="service-type-native">Refferal Type</InputLabel>
            <Select
              id="practice-type-native"
              value={state.refferalType}
              onChange={(event, newValue) => {
                setstate({
                  ...state,
                  refferalType: event.target.value
                });
                console.log("ref", event.target.value);
              }}
              variant="outlined"
              fullWidth
              className={
                specialityTypes === language.select_practice
                  ? classes.inputdimmed
                  : classes.input
              }
            >
              {specialityTypes.map((special) => (
                <MenuItem value={special.value}>{special.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>

        <DialogContent>
          <CustomInput
            labelText={"Reason for Referral"}
            formControlProps={{
              fullWidth: true
            }}
            type="textarea"
            placeholder="Reason for Referral"
            onChange={(e) => {
              setstate({
                ...state,
                refferalNote: e.target.value
              });
            }}
            value={state.refferalNote}
          />
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => makeRefferal()}>
            {"Make Refferal"}
          </Button>
          <Button color="primary" onClick={handleCloseEvent}>
            {"Cancel"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Certificate Dialog */}
      <Dialog
        open={openCModal}
        onClose={handleCClose}
        aria-labelledby="form-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">
          {"Write a Certificate"}
        </DialogTitle>
        <DialogContent>
          <Editor theme="snow" value={certificate} onChange={enterChange} />
          <button onClick={onSave}>SAVE</button>
        </DialogContent>
        <DialogActions>
          <Button fullWidth color="primary" onClick={handleCClose}>
            {"Close"}
          </Button>
        </DialogActions>
      </Dialog>

     

      <style>
       {`
          .tab-header {
            padding: 16px 24px; /* Increased padding */
            cursor: pointer;
            border-bottom: 3px solid transparent;
            transition: all 0.3s;
            margin-bottom: -1px;
          }
          
          .tab-header:hover {
            background-color: #f8f9fa;
          }
          
          .tab-header.active {
            border-bottom: 3px solid #007bff;
            color: #007bff;
            font-weight: bold;
          }
          
          /* Increase font sizes throughout */
          .card-title {
            font-size: 1.4rem;
          }
          
          .card-body {
            font-size: 1.1rem;
          }
          
          .btn {
            font-size: 1.1rem;
          }
          
          .modal-title {
            font-size: 1.5rem;
          }
          
          .modal-body {
            font-size: 1.1rem;
          }
          
          /* Responsive adjustments */
          @media (max-width: 992px) {
            .container-fluid {
              padding-left: 15px;
              padding-right: 15px;
            }
            
            .tab-header {
              padding: 12px 16px;
            }
            
            .btn {
              font-size: 1rem;
            }
          }
          
          @media (max-width: 768px) {
            .tab-header span {
              font-size: 1rem !important;
            }
            
            .btn {
              padding: 0.5rem 1rem;
              font-size: 0.9rem;
            }
          }
        `}
        
      </style>
       </Container>
    </>
  );
};

// InfoItem component remains the same
const InfoItem = ({ label, value }) => (
  <FormGroup>
    <Label className="text-muted small">{label}</Label>
    <p className="font-weight-bold">{value}</p>
  </FormGroup>
);


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: "220px",
    borderRight: "2px solid",
    borderRightColor: "#ff0000",
    borderBlockStartColor: "#ff0000",
    borderBlockStart: "2px solid",
    width: "600px",
  },
  rootThree: {
       paddingTop: "240px", /* Increased padding */
    borderRight: "2px solid",
    borderRightColor: "#ff0000",
    borderBlockStartColor: "#ff0000",
    borderBlockStart: "2px solid",
    width: "650px",
  },
  video: {
    borderRight: "2px solid",
    borderRightColor: "#ff0000",
    borderBlockStartColor: "#ff0000",
    borderBlockStart: "2px solid"
    // height: "600px",
  },
  rootTwo: {
    borderRight: "2px solid",
    borderRightColor: "#ff0000",
    borderBlockStartColor: "#ff0000",
    borderBlockStart: "2px solid",
    height: "670px"
  },
  container: {
    display: "flex",
    // flex: row,
    height: "100%",

    overflow: "hidden",
    position: "right",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  chatlist: {
    width: "240px",
    overflow: "auto"
  },
  header: {
    maxHeight: 250,
    minWidth: 275,
    border: "2px solid black"
  },
  footer: {
    paddingTop: "400px",
    paddingLeft: "500px"
    // border: "2px solid black",
  },
   patientInfoCard: {
   marginBottom: theme.spacing(4), /* Increased spacing */
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3], /* Stronger shadow */
    marginTop: theme.spacing(3)
  },
}));
export default AppointmentScreen;
